module.exports = __webpack_public_path__ + "static/assets/bbf018f66a2d2b8c058dd17bf19930fd.png";